import { useEffect, useState } from "react";
import styled from "styled-components";
import { userContext } from '../../usercontext';

interface Props{
  history?: any;
}

const Billing: React.FC<Props> = (props) => {

  const [user, setUser] = useState<any>(null)

  useEffect(() => {
    const subscription = userContext.user.subscribe((x:any) => setUser(x))
    return () => subscription.unsubscribe()
  }, [])

  useEffect(()=>{
    if(!user)return;
    if(user.status!==200){
      props.history.push("/login")
    }
  },[user])

  return (
    <>
      <MainContainer>
        <Header>Billing</Header>
        <SubHeader>Free subscription</SubHeader>
      </MainContainer>
    </>
  );
};

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

const Header = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 40px;
    justify-content: flex-end;
    color: black;
`;

const SubHeader = styled.div`
    padding: 10px;
    font-weight: 500;
    font-size: 25px;
    justify-content: flex-end;
    color: black;
`;

export default Billing;
